export default __webpack_public_path__ + "static/media/health_check_male_3x2_Cn.3a9585f0.webp";